import { render, staticRenderFns } from "./UsersTabGroups.vue?vue&type=template&id=55a70906"
import script from "./UsersTabGroups.vue?vue&type=script&lang=js"
export * from "./UsersTabGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports